import { isValidElement } from "react";
import { TextMediaAccordionProps } from ".";

export const ImagePreloader = ({ features }: { features: TextMediaAccordionProps['features'] }) => (
  <div className="hidden">
    {features.map((feature, index) => {
      let imageKey: string;

      if (typeof feature.image === 'string') {
        imageKey = feature.image;
      } else if (isValidElement(feature.image) && feature.image.props?.src) {
        imageKey = feature.image.props.src;
      } else {
        imageKey = 'no-src';
      }

      return <div key={`preloaded-image-${index}-${imageKey}`}>{feature.image}</div>;
    })}
  </div>
);
